// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8922af4b","453":"0fafc308","796":"bde93d76"}[chunkId] + ".chunk.js";
};